import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { btnPrimary } from "../components/portfolio/styles";

export default function ComingSoon() {
  return (
    <div
      className="max-w-4xl mx-auto min-h-[70vh] flex flex-col items-center justify-center text-center space-y-8 py-24"
      data-testid="coming-soon-page"
    >
      <div className="flex items-center gap-4 w-full max-w-md">
        <span className="flex-1 border-t border-border" aria-hidden="true" />
        <p className="text-sm font-semibold tracking-[0.25em] text-primary shrink-0">CASE STUDY</p>
        <span className="flex-1 border-t border-border" aria-hidden="true" />
      </div>
      <h1 className="font-display text-5xl md:text-7xl leading-[1.04] tracking-[-0.02em] text-foreground overflow-hidden">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          Coming <em className="italic text-primary">soon.</em>
        </motion.span>
      </h1>
      <p className="text-lg text-muted-foreground leading-relaxed max-w-md">
        This case study is being written. Check back soon — or explore the rest of my work in the
        meantime.
      </p>
      <Link to="/" className={btnPrimary} data-testid="coming-soon-back-btn">
        <ArrowLeft className="h-4 w-4" />
        Back to Home
      </Link>
    </div>
  );
}
